import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
  TextInput,
  Button,
  Spinner
} from "flowbite-react";
import {ArrowRight,ArrowLeft} from "lucide-react"
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation,useNavigate} from "react-router-dom";
const FranchisePage = () => {
const [franchises, setFranchises] = useState([]);
const [loading, setLoading] = useState(false);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(0);
const [totalFranchises, setTotalFranchises] = useState(0);
const [limit] = useState(10);
const location = useLocation()
const navigate = useNavigate()
const roleId = location.state.roleId || null
const fetchCommercials = async (page = 1, search = "") => {
  try {
      setLoading(true);
      const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}getFranchisesByAdminV/${roleId}/?page=${page}&limit=${limit}&search=${search}`,
          { withCredentials: true }
      );
      setFranchises(response.data.franchises);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.currentPage);
      setTotalFranchises(response.data.total);
      setLoading(false);
  } catch (error) {
      console.log(error);
      setLoading(false);
  }
};

const handleSearch = (e) => {
  setSearchTerm(e.target.value);
  setCurrentPage(1); // Reset to first page when searching
};

useEffect(() => {
  const delayDebounceFn = setTimeout(() => {
      fetchCommercials(currentPage, searchTerm);
  }, 500);

  return () => clearTimeout(delayDebounceFn);
}, [searchTerm, currentPage,navigate]);

  return (
    <section className=" dark:bg-gray-900 w-full flex flex-col gap-3 mt-4">
            <div className="grid w-full grid-cols-1">
        <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
          <div className="w-full sm:w-1/2 p-2">
            <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
              Mes Franchises
            </span>
          </div>
          <div className="w-full sm:w-1/2 p-2">
                                <TextInput
                                    type="text"
                                    placeholder="Rechercher..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                            </div>
        </div>
            </div>
            <div className="overflow-x-auto rounded-md">
            <Table striped>
            <TableHead>
              
                <TableHeadCell>Propriétaire</TableHeadCell>
                <TableHeadCell>Nom de la Franchise</TableHeadCell>
                <TableHeadCell>Commercial</TableHeadCell>
                <TableHeadCell>Adresse</TableHeadCell>
               
                
            </TableHead>
            
            <TableBody className="divide-y">
                {franchises?.length ? franchises?.map((franchise, index) => (
                <TableRow key={index} className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300"
                  onClick={()=> navigate(`/franchise/${franchise?._id}`)}
                >
                    <TableCell >{franchise?.owner}</TableCell>
                    <TableCell>{franchise?.pos_franchise_id?.name}</TableCell>
                    <TableCell>{franchise?.commercial?.FirstName+" "+franchise?.commercial?.LastName }</TableCell>
                    <TableCell>{franchise?.pos_franchise_id?.adresse}</TableCell>
                   
                </TableRow>
                )) : 
                <TableRow className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300">
                    <TableCell> {loading ? <Spinner/> : "Aucune franchsie trouvée ."}</TableCell>
                    
                </TableRow>
                }
            </TableBody> 
            </Table>
            </div>
            <section className="md:px-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-md w-full p-2 flex flex-row justify-between">
            <div className="flex justify-center items-center gap-2">
                        <Button
                           disabled={currentPage === 1 || totalPages === 0}
                            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                            color = {"dark"}
                            size="xs"
                        >
                            <ArrowLeft size={16} /> 
                        </Button>
                        <span className="self-center">
                            Page {currentPage} / {totalPages}
                        </span>
                        <Button
                            disabled={currentPage === totalPages || totalPages === 0}
                            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                            color = {"dark"}
                            size="xs"
                        >
                            <ArrowRight size={16} />
                        </Button>
            </div>
            <div>
              <span>Total : {totalFranchises}</span>
            </div>
            </section>
           
    </section> 
  );
};


export default FranchisePage